import React from 'react';
import { Box } from 'rebass';

function FormControlsWell(props) {
  return <Box bg="greys.1" p={4} sx={{ borderRadius: 'medium' }} {...props} />;
}

export default FormControlsWell;
